(() => {
  if (customElements.get('zynea-product')) return;
  customElements.define('zynea-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.railObserver?.observe(this.querySelector('[data-testimonial-rail]')); return; }
      this.ready = true;
      const data = JSON.parse(this.querySelector('[data-product-data]').textContent);
      const select = this.querySelector('[data-variant-select]');
      const groups = [...this.querySelectorAll('[data-position]')];
      const options = this.querySelector('[data-options]');
      const quantity = this.querySelector('[name="quantity"]');
      const phrase = this.querySelector('textarea');
      const add = this.querySelector('[data-add]');
      const form = this.querySelector('form');
      let variant = data.variants.find(v => String(v.id) === select.value);
      const money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: data.currency });
      const render = () => {
        add.disabled = !variant?.available;
        add.textContent = variant ? (variant.available ? 'Comprar minha peça →' : 'Esgotado') : 'Combinação indisponível';
        const addCart = this.querySelector('[data-add-cart]'); if (addCart) addCart.disabled = !variant?.available;
        this.querySelector('[data-price]').textContent = variant ? variant.priceLabel : '—';
        this.querySelector('[data-status]').textContent = variant?.available ? '' : 'Escolha outra combinação de tamanho e cor.';
        const total = this.querySelector('[data-total]');
        total.textContent = variant && quantity.validity.valid ? `Total: ${money.format(variant.price * Number(quantity.value) / 100)}` : '';
        this.querySelector('[data-mobile-total]').textContent = variant && quantity.validity.valid ? money.format(variant.price * Number(quantity.value) / 100) : '—';
        this.querySelector('[data-mobile-buy]').disabled = !variant?.available;
        this.querySelector('[data-decrease]').disabled = Number(quantity.value) <= Number(quantity.min);
        this.querySelector('[data-increase]').disabled = !!quantity.max && Number(quantity.value) >= Number(quantity.max);
      };
      const updateVariant = () => {
        const values = groups.map(g => g.querySelector('input:checked')?.value);
        variant = groups.length ? data.variants.find(v => v.options.every((o,i) => o === values[i])) : data.variants.find(v => String(v.id) === select.value);
        select.value = variant ? String(variant.id) : '';
        if (variant) {
          quantity.min = variant.minimum;
          quantity.step = variant.increment;
          if (variant.maximum) quantity.max = variant.maximum; else quantity.removeAttribute('max');
          if (!quantity.validity.valid) quantity.value = variant.minimum;
        }
        render();
      };
      if (options) {
        groups.forEach((g,i) => g.querySelectorAll('input').forEach(r => { r.checked = r.value === variant?.options[i]; }));
        options.hidden = false;
        select.hidden = true;
        groups.forEach(g => g.addEventListener('change', updateVariant));
      }
      select.addEventListener('change', updateVariant);
      quantity.addEventListener('input', render);
      this.querySelector('[data-decrease]').addEventListener('click', () => { quantity.stepDown(); render(); });
      this.querySelector('[data-increase]').addEventListener('click', () => { quantity.stepUp(); render(); });
      phrase.addEventListener('input', () => {
        phrase.setCustomValidity('');
        this.querySelector('[data-ideas]').hidden = !!phrase.value;
        this.querySelector('[data-counter]').textContent = `${phrase.value.length}/${phrase.maxLength}`;
        this.querySelector('.zynea-message-preview').hidden = !phrase.value.trim();
        this.querySelector('[data-message]').textContent = phrase.value;
      });
      form.addEventListener('submit', e => {
        phrase.setCustomValidity(phrase.value.trim() ? '' : 'Escreva a frase que deseja personalizar.');
        if (!variant?.available || !form.reportValidity()) { e.preventDefault(); return; }
      });
      this.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
        const img = this.querySelector('.zynea-main-image');
        img.removeAttribute('srcset'); img.src = button.dataset.image; img.alt = button.dataset.alt;
        this.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      this.querySelector('[data-mobile-buy]').addEventListener('click', () => { if (!phrase.value.trim()) { phrase.scrollIntoView({block:'center'}); phrase.focus(); } form.requestSubmit(add); });
      this.querySelectorAll('[data-idea]').forEach(b => b.addEventListener('click', () => { phrase.value = b.textContent; phrase.dispatchEvent(new Event('input')); phrase.focus(); }));
      const lightbox = this.querySelector('[data-lightbox]');
      this.querySelector('[data-zoom]').addEventListener('click', () => {
        const source = this.querySelector('.zynea-main-image');
        const target = this.querySelector('[data-large-photo]');
        target.src = source.src; target.alt = source.alt;
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
      });
      this.querySelector('[data-close-zoom]').addEventListener('click', () => lightbox.close());
      const rail = this.querySelector('[data-testimonial-rail]');
      const previous = this.querySelector('[data-testimonial-prev]');
      const next = this.querySelector('[data-testimonial-next]');
      const updateRail = () => { previous.disabled = rail.scrollLeft <= 1; next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1; };
      const moveRail = direction => rail.scrollBy({left: direction * (rail.firstElementChild.getBoundingClientRect().width + 18), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => moveRail(-1));
      next.addEventListener('click', () => moveRail(1));
      rail.addEventListener('scroll', updateRail, {passive:true});
      this.railObserver = new ResizeObserver(updateRail);
      this.railObserver.observe(rail);
      updateRail();
      // Approximate web fonts for the customer preview; order values stay original.
      if (!document.getElementById('zynea-preview-fonts')) {
        const sheet = document.createElement('link');
        sheet.id = 'zynea-preview-fonts'; sheet.rel = 'stylesheet';
        sheet.href = 'https://fonts.googleapis.com/css2?family=Allura&family=Bodoni+Moda&family=Caveat&family=Montserrat&family=Parisienne&display=swap';
        document.head.append(sheet);
      }
      const fontSimulations = {
        'Scandilover Script': ['Allura', 'cursive', 32],
        'Century Gothic': ['Montserrat', 'sans-serif', 19],
        'Handsome': ['Parisienne', 'cursive', 29],
        'Bimbo': ['Caveat', 'cursive', 29],
        'Bodoni': ['Bodoni Moda', 'serif', 25]
      };
      const fontButtons = [...this.querySelectorAll('[name="properties[Tipografia]"]')];
      const messagePreview = this.querySelector('.zynea-message-preview');
      const messageText = this.querySelector('[data-message]');
      const fontHint = this.querySelector('[id^="ZyneaTypographyHint-"]');
      fontHint.textContent = 'Simulação com fontes semelhantes';
      const updateFontPreview = () => {
        const chosen = fontButtons.find(r => r.checked);
        const simulation = chosen && fontSimulations[chosen.value];
        messagePreview.hidden = false;
        messageText.textContent = phrase.value.trim() ? phrase.value : 'Você é meu lugar favorito.';
        messageText.style.fontFamily = simulation ? '"' + simulation[0] + '", ' + simulation[1] : 'inherit';
        messageText.style.fontSize = simulation && simulation[1] === 'cursive' ? '36px' : '28px';
        messageText.style.lineHeight = '1.4';
        messageText.style.whiteSpace = 'pre-wrap';
        messageText.style.overflowWrap = 'anywhere';
        messagePreview.querySelector('small:last-child').textContent = chosen ? 'Simulação aproximada de ' + chosen.value + '. A arte final será confirmada antes da produção.' : 'Escolha uma tipografia para simular sua mensagem.';
      };
      fontButtons.forEach(radio => {
        const [family, fallback, size] = fontSimulations[radio.value];
        const label = radio.nextElementSibling;
        label.style.fontFamily = '"' + family + '", ' + fallback;
        label.style.fontSize = size + 'px'; label.style.lineHeight = '1.4';
        radio.addEventListener('change', updateFontPreview);
      });
      phrase.addEventListener('input', updateFontPreview);
      updateFontPreview();
      render();
    }
    disconnectedCallback() { this.railObserver?.disconnect(); }
  });
})();
